<template class="table-head">
    <div>
        <template class="table-head">
             <el-table  :data="tableDataLists" border height="250" ref="dragTable" >
                    <el-table-column show-overflow-tooltip :prop="item.prop" :label="item.label" :width="item.width" v-for="(item, index) in costTableDataItems" :key="index" ></el-table-column>
            </el-table>
            <div class="pagination">
                    <el-pagination small layout="prev, pager, next" @current-change="pageChange2" :total="tableDataListsLenth"></el-pagination>
            </div>
        </template>
    </div>
</template>
<script>
export default {
    props: {
        costTableDataItems: {
            type: Array
        },
        tableDataLists: {
            type: Array
        },
        tableDataListsLenth: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {};
    },
    methods: {
        pageChange2(page) {
            this.$emit('apBillDeDetail', page);
        }
    },
    mounted() {}
};
</script>

<style lang="less">

</style>